// Constants.
// -----------------------------------------------------------------------------
// Default props.
export const CARD_IMAGE_DEFAULT_PROP_HIDE_IMAGE = false;
// Default values.
export const CARD_IMAGE_MAX_HEIGHT = 180;
export const CARD_IMAGE_MAX_HEIGHT_MOBILE = 104;
export const CARD_IMAGE_MAX_WIDTH = 180;
export const CARD_IMAGE_MAX_WIDTH_MOBILE = 248;
//# sourceMappingURL=Card.constants.js.map